// Use this one to create imports from NPM (the new way).
import Flickity from 'flickity';
import ModuloBox from './plugins/modulobox.js';
import './plugins/gridzy.min.js';

const FlickityLibrary = window.Flickity || Flickity;

const currentDate = new Date();
const endDate     = new Date('2024-07-26');
if(currentDate <= endDate) {
    const notificationElement = document.createElement('div');
    notificationElement.classList.add('notification');
    notificationElement.innerHTML = '<p>Let op: in verband met vakantie van 22 t/m 26 juli 2024 verkoop alleen telefonisch bereikbaar op <a href="tel:+31342414181">0342-414181</a>.</p>';
    document.querySelector('.navbar-container').appendChild(notificationElement);

    setTimeout(() => {
        notificationElement.classList.add('animate-in');
    }, 300);
}

if(document.querySelector('.car-carousel')) {
    new FlickityLibrary('.car-carousel', {
        cellAlign:      'left',
        contain:        true,
        wrapAround:     true,
        groupCells:     true,
        pageDots:       false,
        setGallerySize: false
    });

    const slides                       = document.querySelectorAll('.car-carousel .carousel-cell');
    const handleFlickityViewportChange = () => {
        slides.forEach(slide => slide.style.height = '');

        let heights = Array.from(slides).map((slide) => slide.scrollHeight),
            max     = Math.max(...heights);

        slides.forEach((slide) => slide.style.height = max + 'px');
        const extra                                                             = window.innerWidth >= 767 ? 50 : 50;
        document.querySelector('.car-carousel .flickity-viewport').style.height = (max + extra) + 'px';
    }
    window.addEventListener('resize', handleFlickityViewportChange);
    window.addEventListener('DOMContentLoaded', handleFlickityViewportChange);
}

if(document.querySelector('.carousel-occasion')) {
    document.querySelectorAll('.carousel-occasion').forEach((element) => {
        if(!FlickityLibrary.data(element)) {
            new FlickityLibrary(element, {
                lazyLoad: true,
                fullscreen: true,
                setGallerySize: false,
                pageDots: false
            });
        }
    });

    document.querySelectorAll('.carousel-nav').forEach((element) => {
        if(!FlickityLibrary.data(element)) {
            new FlickityLibrary(element, {
                asNavFor: '.carousel-occasion',
                contain: true,
                pageDots: false
            });
        }
    });
}

document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

if(document.querySelector('.car-details')) {
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if(!entry.isIntersecting) {
                document.querySelector('.car-detail-sticky').classList.add('is-visible');
            } else {
                document.querySelector('.car-detail-sticky').classList.remove('is-visible');
            }
        });
    });

    intersectionObserver.observe(document.querySelector('.car-details'));
}

// Modulobox
const modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div, .page-body :not(a) > img, .gridzy > figure > img',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', function(gallery, index) {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', function(gallery, index) {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();


document.addEventListener('DOMContentLoaded', function() {
    const POPUP_COOKIE_NAME = 'DOMSELAAR_POPUP_CLOSED';
    const DAYS_TO_HIDE      = 1;

    // Cookie handling functions
    const setCookie = (name, value, days) => {
        try {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            const expires   = `; expires=${date.toUTCString()}`;
            document.cookie = `${name}=${value}${expires}; path=/`;
        } catch(error) {
            console.error('Error setting cookie:', error);
        }
    }

    const getCookie = (name) => {
        try {
            const nameEQ  = name + '=';
            const cookies = document.cookie.split(';');

            for(let cookie of cookies) {
                cookie = cookie.trim();
                if(cookie.indexOf(nameEQ) === 0) {
                    return cookie.substring(nameEQ.length);
                }
            }
            return null;
        } catch(error) {
            console.error('Error getting cookie:', error);
            return null;
        }
    }

    // Popup handling
    const handlePopup = () => {
        const modal = document.getElementById('action-modal');
        if(!modal) return;

        const isHomePage  = window.location.pathname === '/';
        const popupClosed = getCookie(POPUP_COOKIE_NAME) === 'true';

        // Show modal if we're on the homepage OR if the user hasn't closed it before
        if(isHomePage || !popupClosed) {
            $('#action-modal').modal();
        }

        // Add event listeners to close buttons
        const closeButtons = modal.querySelectorAll('[data-dismiss="modal"]');
        closeButtons.forEach(button => {
            button.addEventListener('click', () => {
                if(!isHomePage) {
                    setCookie(POPUP_COOKIE_NAME, 'true', DAYS_TO_HIDE);
                }
                $('#action-modal').modal('hide');
            });
        });
    };

    // Initialize popup handling
    try {
        handlePopup();
    } catch(error) {
        console.error('Error initializing popup:', error);
    }
});

document.addEventListener("DOMContentLoaded", function() {
    var bubble   = document.getElementById("whatsappBubble");
    var closeBtn = document.getElementById("closeWhatsappBubble");

    // Alleen tonen op desktop/tablet
    if(window.innerWidth >= 768) {
        setTimeout(function() {
            if(bubble) {
                bubble.classList.add("show");
            }
        }, 10000);
    }

    if(closeBtn) {
        closeBtn.addEventListener("click", function() {
            bubble.classList.remove("show");
        });
    }
});